




import { useEffect, useState } from "react";
import { API } from "../lib/axios";

export default function AnnouncementRotator({
  className = "bg-black text-[#f7f3ef]",
  durationSec = 5, // seconds each message stays visible
}) {
  const [announcements, setAnnouncements] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let mounted = true;
    // Defer announcements loading - not critical for initial render
    const timer = setTimeout(async () => {
      try {
        const res = await API.get("admin/announcements");
        const data = Array.isArray(res.data) ? res.data : [];
        if (mounted && data.length) {
          setAnnouncements(data);
        }
      } catch {
        // Keep empty if API fails
      }
    }, 300); // Defer by 300ms to prioritize critical content

    return () => {
      mounted = false;
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (announcements.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % announcements.length);
    }, durationSec * 1000);
    return () => clearInterval(interval);
  }, [announcements, durationSec]);

  if (hidden) return null;

  return (
    <div className={`relative w-full overflow-hidden ${className}`}>
      <div className="relative mx-auto h-9 sm:h-10">
        {announcements.length === 0 ? (
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="h-3 w-32 bg-white/20 animate-pulse rounded"></span>
          </span>
        ) : (
          announcements.map((item, idx) => (
            <div
              key={item.id ?? idx}
              className={`absolute inset-0 flex items-center justify-center px-4 sm:px-6 text-center transition-all duration-700 ease-in-out
                ${idx === currentIndex
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3 pointer-events-none"}`}
            >
              {item.href ? (
                <a href={item.href} className="hover:underline text-sm font-medium leading-tight max-w-full">
                  {item.text}
                </a>
              ) : (
                <span className="text-sm font-medium leading-tight max-w-full">{item.text}</span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
  
}